import React, { Component } from 'react';
// import { Redirect } from 'react-router-dom';
import { Client } from '../../Client';
import Spinner from '../Spinner/Spinner';
var config = require('../../config');


class Registration extends Component {
	state = {
		inProgress: false,
		registerConfirmation: false,
		fields: {
			email: '',
			password: '',
			// firstname: '',
			// lastname: '',
			company: '',
		},
		hasErrors: false,
		formErrors: {
			email: '',
			password: ''
		},

	};

	performRegistration = (e) => {
		e.preventDefault();
		this.setState({ inProgress: true });
		var data = {
			email: this.state.fields.email, 
			password: this.state.fields.password,
			// firstname: this.state.fields.firstname,
			// lastname: this.state.fields.lastname,
			redirectLink: config.domain + '/account/activation',
		}
		Client.register(data).then((res) => {
			// console.log("Register result: ", res);
			if (res.success === false) {
				var formErrors = {};
				formErrors[res.field] = res.message;
				// console.log("Erro", formErrors);
				this.setState({ hasErrors: true, formErrors: formErrors, inProgress: false });			
			}
			else this.setState({ registerConfirmation: true })
		}).catch((err) => {
			// console.log("thrown error");
			// console.log(err);
			// console.log(err.status);
			// console.log(err.response);
			if (err.status === 'Bad Request') alert("Error");
			// alert("Error logging in: " + err);
			this.setState({ inProgress: false });			
		});
	};

	redirectPath = () => {
		const locationState = this.props.location.state;
		const pathname = (
			locationState && locationState.from && locationState.from.pathname
		);
		// console.log("Redirect", pathname);
		return pathname || '/dashboard';
	};


	handleFieldChange = (e) => {
		const fields = this.state.fields;
		fields[e.target.name] = e.target.value;
		this.setState({ fields });
	};


	render() {
		if (this.state.registerConfirmation) {

			return (
				<div className="bgimage">
					<div className="container page-dashboard style={{ textAlign: 'center' }}">
						
						<div className="row">
							<div className="col-md-6 offset-md-3">

								<div className="card">
									<div className="card-block">
										<h4 className="text-center" style={{marginTop: `10px`, marginBottom: `10px`}}>Account Created!</h4>
		
											<div className="row">
												<div className="col-md-10 offset-md-1">
													<div className="bd-callout bd-callout-info">
														<h5>Check your activation link</h5>
														<p>Check your email and click on the link to <strong>activate your account</strong>.</p>
													</div>
												</div>
											</div>

									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

			);

		} else {
			return (
				<div className="bgimage">
					<div className="container page-dashboard">
						
						{ this.state.inProgress ? (<Spinner/>) : ('') }


						<div className="row">
							<div className="col-md-6 offset-md-3">

								<div className="card">
									<div className="card-block">
										<h4 className="text-center" style={{marginTop: `10px`, marginBottom: `10px`}}>Create your <strong>MyMHP</strong> Account</h4>
										<p className="text-center" style={{marginTop: `20px`, fontSize:`14px`}}>
											Already have an account? <a href="/login">Log in</a>
										</p>

										<form onSubmit={this.performRegistration}>
											{ this.state.hasErrors ? (
												<div className="row">
													<div className="col-md-10 offset-md-1">
														<div className="bd-callout bd-callout-danger">
															<h5>There were errors creating your account</h5>
															<p>Correct the issues listed below to continue</p>
														</div>
													</div>
												</div>
											) : ('') }
											{/* 
											<div className="row">
												<div className="col-md-4 offset-md-2">
													<label htmlFor="inputFirstname" className="col-form-label">Firstname</label>
													<input type="text" name="firstname" className="form-control" id="inputFirstname" placeholder="" value={this.state.fields.firstname} onChange={this.handleFieldChange}/>
													{ this.state.formErrors.firstname ? ( <span className="text-danger">{this.state.formErrors.firstname}</span>) : ('')}
												</div>
												<div className="col-md-4">
													<label htmlFor="inputLastname" className="col-form-label">Lastname</label>
													<input type="text" name="lastname" className="form-control" id="inputLastname" placeholder="" value={this.state.fields.lastname} onChange={this.handleFieldChange}/>
													{ this.state.formErrors.lastname ? ( <span className="text-danger">{this.state.formErrors.lastname}</span>) : ('')}
												</div>
											</div>
											*/}

											<div className="row">
												<div className="col-md-8 offset-md-2">
													<label htmlFor="inputEmail" className="col-form-label">Your Email</label>
													<input type="text" name="email" className="form-control" id="inputEmail" placeholder="you@domain.com" value={this.state.fields.email} onChange={this.handleFieldChange}/>
													{ this.state.formErrors.email ? ( <span className="text-danger">{this.state.formErrors.email}</span>) : ('')}
												</div>
											</div>
											<div className="row">
												<div className="col-md-8 offset-md-2">
													<label htmlFor="inputPassword" className="col-form-label">Password</label>
													<input type="password" name="password" className="form-control" id="inputPassword" placeholder="" value={this.state.fields.password} onChange={this.handleFieldChange}/>
													<p className="small">Minimum 8 characters and at least 1 number</p>
													{ this.state.formErrors.password ? ( <span className="text-danger">{this.state.formErrors.password}</span>) : ('')}
												</div>
											</div>

											<div className="row">
												<div className="col-md-8 offset-md-2" style={{marginTop: '30px', marginBottom: '20px'}}>
													<button type="submit" className="form-control btn btn-primary">
														Next
													</button>
												</div>
											</div>

										</form>

									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			);
		}
	}
}

export default Registration;



// WEBPACK FOOTER //
// ./src/js/components/Registration/Registration.js